import { showAlertError, showAlertExito, showConfirmAlert /* showAlertInfo */ } from '../utils/alertHelper';
import axiosInstance from "./axiosInstance";

const facturar = 'facturar';

// listando Facturaciones lazy
export const listFacturacionesLazy = async (estado = -1, page = 1, limit = 10, buscar = "") => {
    try {
        const response = await axiosInstance.get(`/${facturar}/lazy/${estado}/${page}/${limit}/${buscar}`);
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema, intenta más tarde.");
    }
};

export const envioFactura = async (data) => {
    try {
        const response = await axiosInstance.post(`/${facturar}/enviar_factura`, data);
        return response.data;
    } catch (error) {
        console.error("Error en envio de factura:", error);
        showAlertError("Error inesperado", "Ocurrió un problema al enviar la factura.");
    }
};

// facturacion comprobante credito fiscal
export const FacturacionCCF = async (data) => {
    try {
        const response = await axiosInstance.post(`/${facturar}/ccf`, data);
        showAlertExito("¡Éxito!", "Comprobante de Crédito Fiscal generado exitosamente");
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema, intenta más tarde.");
    }
};

// facturacion consumo final
export const FacturacionFe = async (data) => {
    try {
        const response = await axiosInstance.post(`/${facturar}/fe`, data);
        showAlertExito("¡Éxito!", "Factura de Consumo Final generado exitosamente");
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema, intenta más tarde.");
    }
};

// facturacion sujeto excluido local
export const FacturacionSujetoExcluido = async (data) => {
    try {
        const response = await axiosInstance.post(`/${facturar}/sujeto_excluido`, data);
        showAlertExito("¡Éxito!", "Factura de Sujeto Excluido generado exitosamente");
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema, intenta más tarde.");
    }
};

// facturacion exportacion
export const FacturacionExportacion = async (data) => {
    try {
        const response = await axiosInstance.post(`/${facturar}/exportacion`, data);
        showAlertExito("¡Éxito!", "Factura de Exportación generada exitosamente");
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema, intenta más tarde.");
    }
};

// facturacion ticket
export const FacturacionTicket = async (data) => {
    try {
        const response = await axiosInstance.post(`/${facturar}/ticket`, data);
        showAlertExito("¡Éxito!", "Ticket generado exitosamente");
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema, intenta más tarde.");
    }
};

// Anulacion de comprobante
export const Anulacion = async (data) => {
    try {
        const response = await axiosInstance.post(`/${facturar}/anulacion`, data);
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema, intenta más tarde.");
    }
};

// firmado de documentos tributarios
export const Firmador = async (data, dteSerial) => {
    try {
        const confirmar = await showConfirmAlert(
            "¿Deseas presentar el documento?",
            `Esta acción enviará la factura a Hacienda<br><strong>${dteSerial}</strong>`,
        );
        if (!confirmar) return;
        try {
            const response = await axiosInstance.post(`/${facturar}/firmador`, data);
            return response.data;
        } catch (error) {
            showAlertError("Error inesperado", "Documento no firmado verifique datos de hacienda o ruta firmadora.");
        }
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema, intenta más tarde.");
    }
};

// Presentando facturacion a hacienda
export const presentacionHacienda = async (data) => {
    try {
        const response = await axiosInstance.post(`/${facturar}/presentacion_hacienda`, data);
        if (response.data.estado === 1) {
            showAlertExito("¡Éxito!", "Documento presentado en hacienda exitosamente");
        } else {
            const detalle = response.data.detalle;
            showAlertError(
                "Error inesperado",
                `Estado: ${detalle.estado}
                 Código: ${detalle.codigoMsg}
                 Descripción: ${detalle.descripcionMsg}
                 Observaciones: ${detalle.observaciones}`
            );
        }
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema, intenta más tarde.");
    }
};


// Presentando facturacion a hacienda
export const presentar_anulacion = async (data, dteSerial) => {
    try {
        const confirmar = await showConfirmAlert(
            "¿Deseas anular el documento?",
            `Esta acción enviará la factura a Hacienda<br><strong>${dteSerial}</strong>`,
        );

        if (!confirmar) return;

        const response = await axiosInstance.post(`/${facturar}/presentar_anulacion`, data);
        showAlertExito("¡Éxito!", "Documento anulado en hacienda exitosamente");
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema, intenta más tarde.");
    }
};




// firmado de documentos tributarios
export const Token = async (data) => {
    try {
        const response = await axiosInstance.post(`/${facturar}/firmador`, data);
        showAlertExito("¡Éxito!", "Documento firmado exitosamente");
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema, intenta más tarde.");
    }
};

// eliminando documentos tributarios
export const EliminarDTE = async (data) => {
    try {
        const response = await axiosInstance.post(`/${facturar}/eliminar_dte`, data);
        showAlertExito("¡Éxito!", "Documento eliminado exitosamente");
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema, intenta más tarde.");
    }
};

// Nota de crédito
export const NotaCredito = async (data) => {
    try {
        const response = await axiosInstance.post(`/${facturar}/nota_credito`, data);
        showAlertExito("¡Éxito!", "Nota de crédito generada exitosamente");
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema al generar la nota de crédito.");
    }
};